import { IdpGroupRolesBulkActions } from "./types";

export const BULK_ACTION_RESULTS_TITLE: Record<IdpGroupRolesBulkActions, string> = {
  [IdpGroupRolesBulkActions.Delete]: "Unassign IdP group roles results",
};

export const BULK_ACTION_NAMES: Record<IdpGroupRolesBulkActions, string> = {
  [IdpGroupRolesBulkActions.Delete]: "Unassign",
};
